var map = {
	"./Alangoo.png": 67,
	"./Angoshtar.png": 68,
	"./Aviz.png": 69,
	"./Dastband.png": 70,
	"./Else.png": 71,
	"./GardanBand.png": 72,
	"./Gooshvare.png": 73,
	"./Halghe.png": 74,
	"./Koodak.png": 75,
	"./Lazer.png": 76,
	"./Medal.png": 77,
	"./Motefareghe.png": 78,
	"./NimSet.png": 79,
	"./Paband.png": 80,
	"./RooLebasi.png": 81,
	"./Saat.png": 82,
	"./Sekke.png": 83,
	"./Servis.png": 84,
	"./Zanjir.png": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;